import { Button, Col, Form, Row, Text, TextAreaInput } from 'ui';
import { useRemoveAccountConfirmModal } from './hooks';

type P = {
  logOut: () => void;
};

type RemoveAccountFormValues = {
  deleteReason?: string;
};

const RemoveAccountForm = ({ logOut }: P) => {
  const {
    confirm,
    contextHolder,
    isLoading: isRemoveAccountIsLoading,
  } = useRemoveAccountConfirmModal({
    logOut,
  });

  const onFinish = (data: RemoveAccountFormValues) => {
    confirm({ deleteReason: data.deleteReason });
  };

  return (
    <Form<RemoveAccountFormValues> onFinish={onFinish}>
      <TextAreaInput
        item={{
          label: 'Reason of your request',
          name: 'deleteReason',
          rules: [
            {
              whitespace: true,
            },
          ],
        }}
      />

      <Row gutter={[0, 'lg']}>
        <Col span={24}>
          <Text>You will be logged out from your account immediately after this action.</Text>
        </Col>
        <Col span={24}>
          <Button danger htmlType="submit" loading={isRemoveAccountIsLoading} size="large" type="primary">
            Remove account
          </Button>
        </Col>
      </Row>
      {contextHolder}
    </Form>
  );
};

export default RemoveAccountForm;
